import app from 'flarum/forum/app';

import config from '../common/config';
import ShareModal from './components/ShareModal';
import setupSDK from './setupSDK';
import setupLogin from './setupLogin';
import addWeComShare from './addWecomShare';

app.initializers.add(config.module.key, () => {
  const corpId = app.data.resources[0].attributes?.[config.setting.corpId] as string;
  const agentId = app.data.resources[0].attributes?.[config.setting.agentId] as string;

  setupSDK(corpId, agentId);
  setupLogin(corpId, agentId);
  addWeComShare(corpId, agentId);

  app.modalComponents = {
    ...app.modalComponents,
    ShareModal,
  };
});
